import React from 'react'
import HospitalDoctors from '../../components/HospitalDoctors/HospitalDoctors'

function HospitalDoctorPage() {
  return (
    <HospitalDoctors />
  )
}

export default HospitalDoctorPage